import React from 'react';
import { number } from 'prop-types';
import { Text } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';

const TotalGigsCount = ({ total = 0 }) => {
    if (total <= 0) {
        return null;
    }

    return (
        <Text paddingLeft="3" color="grey_900" fontWeight="semibold" size="b_sm">
            <I18n k="tag_page_perseus.pagination.number_of_results" params={{ total }} />
        </Text>
    );
};

TotalGigsCount.propTypes = {
    total: number,
};
export default TotalGigsCount;
